export const vehicleTypeOptions = [
    { label: "Truck", value: "Truck" },
    { label: "Car", value: "Car" },
    { label: "Van", value: "Van" },
];

export const getVehicleTypeOptions = (t) =>
    vehicleTypeOptions.map((option) => ({
        ...option,
        label: t(`vehicle.type.${option.value}`, { defaultValue: option.label }),
    }));

export const electricTruckBrandsOptions = [
    { label: "Volvo Trucks", value: "Volvo Trucks" },
    { label: "Mercedes-Benz Trucks", value: "Mercedes-Benz Trucks" },
    { label: "DAF", value: "DAF" },
    { label: "Scania", value: "Scania" },
    { label: "MAN", value: "MAN" },
    { label: "BYD", value: "BYD" },
    { label: "Iveco", value: "Iveco" },
    { label: "Windrose", value: "Windrose" },
];

export const electricTruckModelsByBrand = {
    "Volvo Trucks": [
        { label: "Volvo FL Electric", value: "Volvo FL Electric" },
        { label: "Volvo FE Electric", value: "Volvo FE Electric" },
        { label: "Volvo FM Electric", value: "Volvo FM Electric" },
        { label: "Volvo FM Low Entry Electric", value: "Volvo FM Low Entry Electric" },
        { label: "Volvo FMX Electric", value: "Volvo FMX Electric" },
        { label: "Volvo FH Electric", value: "Volvo FH Electric" },
        { label: "Volvo FH Aero Electric", value: "Volvo FH Aero Electric" }
    ],
    "Mercedes-Benz Trucks": [
        { label: "Mercedes eActros 300", value: "Mercedes eActros 300" },
        { label: "Mercedes eActros 400", value: "Mercedes eActros 400" },
        { label: "Mercedes eActros 600", value: "Mercedes eActros 600" }
    ],
    "BYD": [
        { label: "BYD 8TT", value: "BYD 8TT" },
        { label: "BYD ETM6", value: "BYD ETM6" },
        { label: "BYD ETH8", value: "BYD ETH8" }
    ],
    "DAF": [{ label: "DAF Electric Truck (various models)", value: "DAF Electric Truck" }],
    "Scania": [
        { label: "Scania 25 P / 25 L BEV", value: "Scania 25 P / 25 L BEV" },
        { label: "Scania 45 R BEV", value: "Scania 45 R BEV" }
    ],
    "MAN": [{ label: "MAN eTGM", value: "MAN eTGM" }],
    "Iveco": [{ label: "Iveco Electric Models", value: "Iveco Electric Models" }],
    "Windrose": [{ label: "Windrose Electric Trucks", value: "Windrose Electric Trucks" }],
};